import BaseApi from '../base/base'
import VoteForm from '../../forms/vote'
import Vote from '../../models/vote'

export default class VoteApi extends BaseApi {
  constructor() {
    super()
    this.path = '/votes'
  }

  async create(params: VoteForm) {
    this.path = '/votes'
    const response = await this.postRequest(params)
    return new Vote(response.data)
  }
}
